import PropTypes from "prop-types";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { SELF_REGISTRATION_ENABLED, showSelfRegistrationDisabledToast } from "@/lib/registration";

/** Blocks public self-registration funnel routes when disabled; renders page when enabled. */
export function SignupRouteGuard({ page: Page }) {
  useEffect(() => {
    if (!SELF_REGISTRATION_ENABLED) showSelfRegistrationDisabledToast();
  }, []);

  if (!SELF_REGISTRATION_ENABLED) return <Navigate to="/login" replace />;
  return <Page />;
}

SignupRouteGuard.propTypes = {
  page: PropTypes.elementType.isRequired,
};
